import { useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/useCart";
import CartDrawer from "./CartDrawer";
import styles from "./ShopCartPill.module.css";

/**
 * Floating cart affordance shown only on the shop browsing pages (never in the
 * global header). Renders nothing until the cart has items, then opens a
 * slide-out drawer (not a full page). Pinned top-right just under the nav.
 * useCart is SSR-safe (empty on prerender), so the pill appears on the client
 * once localStorage is read. The drawer stays mounted regardless so it can
 * animate closed and show an empty state when the last item is removed.
 */
export default function ShopCartPill() {
  const { count } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <>
      {count > 0 && (
        <button
          type="button"
          className={styles.pill}
          onClick={() => setOpen(true)}
          aria-label={`Cart, ${count} item${count === 1 ? "" : "s"}`}
        >
          <ShoppingBag size={16} aria-hidden="true" />
          <span className={styles.label}>Cart</span>
          <span className={styles.count}>{count}</span>
        </button>
      )}
      <CartDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
